module.exports = __webpack_public_path__ + "img/underlyingDiseaseFamily.2254a724.png";